var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6658 36.4444C9.21559 36.4444 1.55469 28.7835 1.55469 19.3333C1.55469 9.88307 9.21559 2.22217 18.6658 2.22217C28.116 2.22217 35.7769 9.88307 35.7769 19.3333C35.7769 28.7835 28.116 36.4444 18.6658 36.4444ZM30.1761 27.305C31.7459 25.0427 32.6658 22.2954 32.6658 19.3333C32.6658 11.6013 26.3978 5.33328 18.6658 5.33328C10.9338 5.33328 4.6658 11.6013 4.6658 19.3333C4.6658 22.2954 5.58573 25.0427 7.15547 27.305C8.90617 24.9925 13.0201 23.9999 18.6658 23.9999C24.3115 23.9999 28.4254 24.9925 30.1761 27.305ZM27.9442 29.8174C27.4889 28.1803 24.2182 27.1111 18.6658 27.1111C13.1134 27.1111 9.84269 28.1803 9.3874 29.8174C11.8576 32.0051 15.1066 33.3333 18.6658 33.3333C22.225 33.3333 25.474 32.0051 27.9442 29.8174ZM18.6658 23.9999C15.1827 23.9999 12.4436 21.5536 12.4436 16.2222C12.4436 12.7311 14.9 9.99995 18.6658 9.99995C22.4212 9.99995 24.888 12.9891 24.888 16.5333C24.888 21.6349 22.1162 23.9999 18.6658 23.9999ZM15.5547 16.2222C15.5547 19.7521 16.8275 20.8888 18.6658 20.8888C20.4978 20.8888 21.7769 19.7974 21.7769 16.5333C21.7769 14.5895 20.5568 13.1111 18.6658 13.1111C16.6961 13.1111 15.5547 14.3801 15.5547 16.2222Z",
    fill: "#0681BA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e170d3cd66c656cc6e1502df0359d8b1.svg";
export { ForwardRef as ReactComponent };